import React from "react";

export default function Footer() {
  return <footer className="auth-footer"> © 2020 Fancify </footer>;
}
